import React from 'react';
import PropTypes from 'prop-types';

export const SharingIcon = ({ listName }) => (
  <svg width="480" height="232" viewBox="0 0 480 232" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_50593_167723)">
      <g filter="url(#filter0_dd_50593_167723)">
        <g clipPath="url(#clip1_50593_167723)">
          <path d="M40 24C40 19.5817 43.5817 16 48 16H432C436.418 16 440 19.5817 440 24V216H40V24Z" fill="white" />
          <rect width="400" height="20" transform="translate(40 16)" fill="#EDF2F7" />
          <circle cx="53" cy="26" r="4" fill="#DEE4ED" />
          <circle cx="65" cy="26" r="4" fill="#DEE4ED" />
          <circle cx="77" cy="26" r="4" fill="#DEE4ED" />

          <text x="72" y="68" fontFamily="Silka, sans-serif" fontSize="13" fontWeight="600" fill="#090925">
            {listName}
          </text>

          <mask id="path-6-inside-1_50593_167723" fill="white">
            <path d="M72 87.3329H440V160.148H72V87.3329Z" />
          </mask>
          <path d="M72 87.3329H440V160.148H72V87.3329Z" fill="white" />
          <path
            d="M440 160.148V159.743H72V160.148V160.552H440V160.148Z"
            fill="#EDF2F7"
            mask="url(#path-6-inside-1_50593_167723)"
          />
          <circle cx="88.1811" cy="103.514" r="16.1811" fill="#EDF2F7" />
          <rect x="110.835" y="90.5692" width="80.9054" height="6.47244" rx="3.23622" fill="#EDF2F7" />
          <rect x="110.835" y="103.514" width="186.083" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="110.835" y="111.605" width="145.63" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="110.835" y="126.168" width="97.0865" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="110.835" y="134.258" width="80.9054" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="110.835" y="142.349" width="64.7244" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <line x1="320.462" y1="87.3329" x2="320.462" y2="147.203" stroke="#EDF2F7" strokeWidth="0.404527" />
          <rect x="326.732" y="90.5692" width="48.5433" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="326.732" y="101.896" width="48.5433" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="326.732" y="113.223" width="48.5433" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <mask id="path-19-inside-2_50593_167723" fill="white">
            <path d="M72 167.833H440V240.648H72V167.833Z" />
          </mask>
          <path d="M72 167.833H440V240.648H72V167.833Z" fill="white" />
          <path
            d="M440 240.648V240.243H72V240.648V241.052H440V240.648Z"
            fill="#EDF2F7"
            mask="url(#path-19-inside-2_50593_167723)"
          />
          <circle cx="88.1811" cy="184.014" r="16.1811" fill="#EDF2F7" />
          <rect x="110.835" y="171.069" width="80.9054" height="6.47244" rx="3.23622" fill="#EDF2F7" />
          <rect x="110.835" y="184.014" width="186.083" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="110.835" y="192.105" width="145.63" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="110.835" y="206.668" width="97.0865" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="110.835" y="214.758" width="80.9054" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <line x1="320.462" y1="167.833" x2="320.462" y2="227.703" stroke="#EDF2F7" strokeWidth="0.404527" />
          <rect x="326.732" y="171.069" width="48.5433" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="326.732" y="182.396" width="48.5433" height="4.85433" rx="2.42716" fill="#EDF2F7" />
          <rect x="326.732" y="193.723" width="48.5433" height="4.85433" rx="2.42716" fill="#EDF2F7" />
        </g>
      </g>
      <rect y="180" width="480" height="52" fill="url(#paint0_linear_50593_167723)" />
    </g>
    <defs>
      <filter
        id="filter0_dd_50593_167723"
        x="8"
        y="-14"
        width="464"
        height="264"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="16" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.105882 0 0 0 0 0.141176 0 0 0 0 0.196078 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_50593_167723" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.105882 0 0 0 0 0.141176 0 0 0 0 0.196078 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_50593_167723" result="effect2_dropShadow_50593_167723" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_50593_167723" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_50593_167723"
        x1="233.347"
        y1="180"
        x2="233.347"
        y2="215.389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_50593_167723">
        <rect width="480" height="232" fill="white" />
      </clipPath>
      <clipPath id="clip1_50593_167723">
        <path d="M40 24C40 19.5817 43.5817 16 48 16H432C436.418 16 440 19.5817 440 24V216H40V24Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

SharingIcon.propTypes = {
  listName: PropTypes.string.isRequired,
};
